// extracted by mini-css-extract-plugin
export default {"row":"Payments_row__ntoha","loadingWrapper":"Payments_loadingWrapper__FL6GE"};